import { render, staticRenderFns } from "./getCurrentPosition.vue?vue&type=template&id=c3812508&scoped=true&"
import script from "./getCurrentPosition.vue?vue&type=script&lang=js&"
export * from "./getCurrentPosition.vue?vue&type=script&lang=js&"
import style0 from "./getCurrentPosition.vue?vue&type=style&index=0&id=c3812508&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3812508",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VContainer,VIcon})
